function SeasonalityController($rootScope) {
}

SeasonalityController.$inject = ["$rootScope"];

module.exports.stateConfig = {
    name: "seasonality",
    url: "/seasonality",
    template: require("./seasonality.insights.html"),
    display: "Insights",
    data: {
      permissions: ['seasonality']
    },
    controller: SeasonalityController,
    context: {}
};
